
import newsJson from '../json/news.json';
import { onMounted, ref } from 'vue';
import log from '@/global/log';
import router from '@/router';
export default {
	setup() {
		let activeTab = ref('전체 소식');
		let tabPositionTop = ref();
		let showCnt = ref(10);
		let showOffset = ref(10);

		function resolveUrl(path) {
			let images = require.context(
				'@/assets/images/news/',
				false,
				/\.(png|jpg|webp)$/
			);
			return images('./' + path);
		}

		function onScroll(top: number, _: any) {
			const tabEl = document.getElementById(
				'tab'
			) as HTMLElement;

			const headerEl = document.querySelector(
				'header'
			) as HTMLElement;
			const headerStyles =
				window.getComputedStyle(headerEl);
			// height 속성을 가져와서 높이를 얻습니다.
			const headerHeight: string =
				headerStyles.getPropertyValue('height');
			// 숫자만 추출하는 정규식 패턴
			const pattern = /\d+/; // 정규식을 사용하여 숫자를 추출
			const matches = headerHeight.match(pattern);
			const headerHeightInt = parseInt(
				matches![0],
				10
			);
			log('headerHeight :' + headerHeightInt);

			if (
				top >
				tabPositionTop.value - headerHeightInt
			) {
				// 요소가 스크롤 최상단에 위치함
				// 원하는 작업 수행

				log('onScroll at news top');
				tabEl.classList.add('fix');
			} else {
				// 요소가 스크롤 최상단에 위치하지 않음
				// 다른 작업 수행
				log('onScroll at news not top');
				tabEl.classList.remove('fix');
			}
		}

		// 요소의 스크롤 탑 위치 확인
		function isElementAtTop(
			element: HTMLElement
		) {
			const rect =
				element.getBoundingClientRect();
			return rect.top;
		}

		onMounted(() => {
			const tabEl = document.getElementById(
				'tab'
			) as HTMLElement;
			tabPositionTop.value =
				isElementAtTop(tabEl);

			const screenWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			if (screenWidth < 768) {
				showCnt.value = 6;
				showOffset.value = 6;
			}
		});

		function showMore() {
			showOffset.value =
				showOffset.value + showCnt.value;
		}

		return {
			activeTab,
			tabArr: [
				'전체 소식',
				// '공지사항',
				'언론보도',
			],
			onScroll,
			newsJson,
			resolveUrl,
			showOffset,
			showCnt,
			showMore,
		};
	},
};
